import { gql } from "@apollo/client";

const PLATFORM_PARTNERS = gql`
  query platformPartners($filter: ListPartnerInput) {
    platformPartners(filter: $filter) {
      id
      title
      image
      link
      priority
      activeFrom
      activeTo
      league {
        id
      }
      federation {
        id
      }
      club {
        id
      }
    }
  }
`;

export default PLATFORM_PARTNERS;
